import { styled } from 'react-ui-kit-exante';

export const StyledPhoneWithFlag = styled('span')`
  display: flex;
  align-items: center;
  gap: 8px;
`;
